import React, { useState } from 'react';
import '@/index.css';
import '@/App.css';
import '@/i18n';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { CartProvider } from '@/context/CartContext';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { LeadCaptureModal } from '@/components/forms/LeadCaptureModal';
import { FloatingLanguageSwitcher } from '@/components/common/FloatingLanguageSwitcher';
import { Home } from '@/pages/Home';
import { Pavers } from '@/pages/Pavers';
import { BrickColors } from '@/pages/BrickColors';
import { Remodeling } from '@/pages/Remodeling';
import { Projects } from '@/pages/Projects';
import { About } from '@/pages/About';
import { Contact } from '@/pages/Contact';
import { Shop } from '@/pages/Shop';
import { Cart } from '@/pages/Cart';
import { AdminLogin } from '@/pages/AdminLogin';
import { AdminDashboard } from '@/pages/AdminDashboard';

function App() {
  const [isLeadModalOpen, setIsLeadModalOpen] = useState(false);

  return (
    <CartProvider>
      <div className="App">
        <BrowserRouter>
          <Header onOpenLeadModal={() => setIsLeadModalOpen(true)} />
          <main style={{ paddingTop: '5rem' }}>
            <Routes>
              <Route
                path="/"
                element={<Home onOpenLeadModal={() => setIsLeadModalOpen(true)} />}
              />
              <Route path="/pavers" element={<Pavers onOpenLeadModal={() => setIsLeadModalOpen(true)} />} />
              <Route path="/brick-colors" element={<BrickColors onOpenLeadModal={() => setIsLeadModalOpen(true)} />} />
              <Route path="/remodeling" element={<Remodeling onOpenLeadModal={() => setIsLeadModalOpen(true)} />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/edx-admin" element={<AdminLogin />} />
              <Route path="/edx-dashboard" element={<AdminDashboard />} />
              <Route path="/edx-control-panel/login" element={<AdminLogin />} />
              <Route path="/edx-control-panel" element={<AdminDashboard />} />
            </Routes>
          </main>
          <Footer />
          <FloatingLanguageSwitcher />
          <LeadCaptureModal
            isOpen={isLeadModalOpen}
            onClose={() => setIsLeadModalOpen(false)}
          />
          <Toaster position="top-right" richColors />
        </BrowserRouter>

        {/* Analytics Placeholders */}
        <div id="analytics-scripts">
          {/* Google Analytics - Add GA4 tracking ID when ready */}
          {process.env.REACT_APP_GA_TRACKING_ID && (
            <>
              <script async src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GA_TRACKING_ID}`}></script>
              <script
                dangerouslySetInnerHTML={{
                  __html: `
                    window.dataLayer = window.dataLayer || [];
                    function gtag(){dataLayer.push(arguments);}
                    gtag('js', new Date());
                    gtag('config', '${process.env.REACT_APP_GA_TRACKING_ID}');
                  `,
                }}
              />
            </>
          )}

          {/* Google Ads - Add conversion tracking ID when ready */}
          {process.env.REACT_APP_GOOGLE_ADS_ID && (
            <script async src={`https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GOOGLE_ADS_ID}`}></script>
          )}

          {/* Meta Pixel - Add pixel ID when ready */}
          {process.env.REACT_APP_META_PIXEL_ID && (
            <script
              dangerouslySetInnerHTML={{
                __html: `
                  !function(f,b,e,v,n,t,s)
                  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                  n.queue=[];t=b.createElement(e);t.async=!0;
                  t.src=v;s=b.getElementsByTagName(e)[0];
                  s.parentNode.insertBefore(t,s)}(window, document,'script',
                  'https://connect.facebook.net/en_US/fbevents.js');
                  fbq('init', '${process.env.REACT_APP_META_PIXEL_ID}');
                  fbq('track', 'PageView');
                `,
              }}
            />
          )}
        </div>
      </div>
    </CartProvider>
  );
}

export default App;